// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Minoxidil / Finasteride /Tret  (Men & Women) 09.17.26" (bfe282ed-e0e7-45df-a520-1611e1b1b098). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiMinoxidilFinasterideTretMenWomenAnswerField } from './questions';

export const mdiMinoxidilFinasterideTretMenWomen: FormType<mdiMinoxidilFinasterideTretMenWomenAnswerField> =
  {
    name: 'Minoxidil / Finasteride /Tret (Men & Women)',
    validityLength: 25,
    questions: [
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_sex',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_pregnancy'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_pregnancy.yes': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryDueEitherBeing'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.male': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryBasedPreviousResponse'
            }
          ],
          els: 'mdiMinoxidilFinasterideTretMenWomen_primaryConcern'
        }
      },
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_pregnancy',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_pregnancy.yes': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryDueEitherBeing'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.male': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryBasedPreviousResponse'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_requiredAcknowledgmentUnderstandFormulationContains'
            }
          ],
          els: 'mdiMinoxidilFinasterideTretMenWomen_primaryConcern'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_wereSorryDueEitherBeing',
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_tryingConceivePlanConceivingNear.yes':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_wereSorryBasedPreviousResponse'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_requiredAcknowledgmentUnderstandFormulationContains'
            }
          ],
          els: 'mdiMinoxidilFinasterideTretMenWomen_primaryConcern'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_wereSorryBasedPreviousResponse',
      'mdiMinoxidilFinasterideTretMenWomen_requiredAcknowledgmentUnderstandFormulationContains',
      'mdiMinoxidilFinasterideTretMenWomen_primaryConcern',
      'mdiMinoxidilFinasterideTretMenWomen_didFirstNoticeHairLoss',
      'mdiMinoxidilFinasterideTretMenWomen_whereHairLossOccurring',
      'mdiMinoxidilFinasterideTretMenWomen_hairLoss',
      'mdiMinoxidilFinasterideTretMenWomen_familyHistoryHairLoss',
      'mdiMinoxidilFinasterideTretMenWomen_conditions',
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_everDiagnosed',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_everDiagnosed.androgenetic_alopecia':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRegarding'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_everDiagnosed.alopecia_areata':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRegarding'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_everDiagnosed.telogen_effluvium':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRegarding'
            }
          ],
          els: 'mdiMinoxidilFinasterideTretMenWomen_usingHairLossTreatmentsIncludes'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRegarding',
      'mdiMinoxidilFinasterideTretMenWomen_usingHairLossTreatmentsIncludes',
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_youuseProducts',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.minoxidil':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.retinoids_e_g_tretinoin':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.finasteride':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.dutasteride':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.ketoconazole_shampoo':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.microneedling':
                  true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_youuseProducts.prp': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried'
            }
          ],
          els: 'mdiMinoxidilFinasterideTretMenWomen_scalpIrritationOpenWoundsInfection'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_experienceProductsTried',
      'mdiMinoxidilFinasterideTretMenWomen_scalpIrritationOpenWoundsInfection',
      'mdiMinoxidilFinasterideTretMenWomen_redness',
      'mdiMinoxidilFinasterideTretMenWomen_history',
      'mdiMinoxidilFinasterideTretMenWomen_usingScalp',
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_historyLowBloodPressureDizziness',
        next: {
          switch: [
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.female': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experiencedDecreasedLibidoLately'
            },
            {
              condition: {
                'mdiMinoxidilFinasterideTretMenWomen_sex.male': true
              },
              key: 'mdiMinoxidilFinasterideTretMenWomen_experienced'
            }
          ],
          els: 'mdiMinoxidilFinasterideTretMenWomen_historyDepressionAnxietyMoodDisorders'
        }
      },
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_experiencedDecreasedLibidoLately',
        next: {
          condition: { 'mdiMinoxidilFinasterideTretMenWomen_sex.male': true },
          key: 'mdiMinoxidilFinasterideTretMenWomen_experienced',
          els: 'mdiMinoxidilFinasterideTretMenWomen_historyDepressionAnxietyMoodDisorders'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_experienced',
      'mdiMinoxidilFinasterideTretMenWomen_historyDepressionAnxietyMoodDisorders',
      'mdiMinoxidilFinasterideTretMenWomen_provideDoctorFurtherInsightHistory',
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_history2',
        next: {
          condition: { 'mdiMinoxidilFinasterideTretMenWomen_sex.male': true },
          key: 'mdiMinoxidilFinasterideTretMenWomen_ever',
          els: 'mdiMinoxidilFinasterideTretMenWomen_rateStressLevelDailyBasis'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_ever',
      'mdiMinoxidilFinasterideTretMenWomen_rateStressLevelDailyBasis',
      {
        key: 'mdiMinoxidilFinasterideTretMenWomen_experiencedRecentMajorStressIllness',
        next: {
          condition: {
            'mdiMinoxidilFinasterideTretMenWomen_experiencedRecentMajorStressIllness.yes':
              true
          },
          key: 'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRecent',
          els: 'mdiMinoxidilFinasterideTretMenWomen_uploadClearWellLitPhoto'
        }
      },
      'mdiMinoxidilFinasterideTretMenWomen_provideDoctorMoreInsightRecent',
      'mdiMinoxidilFinasterideTretMenWomen_uploadClearWellLitPhoto',
      'mdiMinoxidilFinasterideTretMenWomen_firstMessageDoctor',
      'mdiMinoxidilFinasterideTretMenWomen_complete'
    ]
  };
